import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7abe8089"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex flex-column flex-wrap flex-sm-nowrap p-0" }
const _hoisted_4 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_6 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_8 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_9 = {
  key: 2,
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_10 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_11 = {
  key: 3,
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_12 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_13 = { class: "card mb-5 mb-xl-10" }
const _hoisted_14 = { class: "card-header" }
const _hoisted_15 = { class: "card-title m-0" }
const _hoisted_16 = { class: "fw-boldest m-0" }
const _hoisted_17 = { class: "card-body p-9" }
const _hoisted_18 = { class: "timeline-label fw-bold fs-6" }
const _hoisted_19 = {
  key: 0,
  class: "bi bi-cart fs-6 text-white"
}
const _hoisted_20 = {
  key: 1,
  class: "bi bi-receipt fs-6 text-white"
}
const _hoisted_21 = {
  key: 2,
  class: "bi bi-journal-check fs-6 text-white"
}
const _hoisted_22 = {
  key: 3,
  class: "bi bi-send-check fs-6 text-white"
}
const _hoisted_23 = {
  key: 4,
  class: "bi bi-cart-check fs-6 text-white"
}
const _hoisted_24 = {
  key: 5,
  class: "bi bi-truck fs-6 text-white"
}
const _hoisted_25 = {
  key: 6,
  class: "bi bi-truck fs-6 text-white"
}
const _hoisted_26 = {
  key: 7,
  class: "bi bi-truck fs-6 text-white"
}
const _hoisted_27 = {
  key: 8,
  class: "bi bi-shield-check fs-6 text-white"
}
const _hoisted_28 = {
  key: 9,
  class: "bi bi-inboxes fs-6 text-white"
}
const _hoisted_29 = {
  key: 10,
  class: "bi bi-box-arrow-right fs-6 text-white"
}
const _hoisted_30 = {
  key: 11,
  class: "bi bi-box-arrow-in-right fs-6 text-white"
}
const _hoisted_31 = {
  key: 12,
  class: "bi bi-box fs-6 text-white"
}
const _hoisted_32 = { class: "fw-mormal timeline-content ps-6" }
const _hoisted_33 = { class: "timeline-label fw-bold fs-6" }
const _hoisted_34 = { class: "timeline-badge" }
const _hoisted_35 = { class: "fw-mormal fs-6 timeline-content ps-6" }
const _hoisted_36 = {
  key: 0,
  class: "w-100 d-flex align-items-center justify-content-center"
}
const _hoisted_37 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.formData.order_number_encry
                ? "#" + _ctx.formData.order_number_encry
                : "") + " " + _toDisplayString(_ctx.formData.order_number_encry && _ctx.formData.product?.name ? " / " : "") + " " + _toDisplayString(_ctx.formData.product?.name), 1),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.formData.product?.__show?.brand_id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen056.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formData.product?.__show?.brand_id), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.product?.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formData.product?.sku), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.product?.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen017.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formData.product?.__show?.size
                  ? _ctx.formData.product?.__show?.size + " "
                  : "") + _toDisplayString(_ctx.formData.product?.__show?.color), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.product?.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm009.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("order.qty")) + ": " + _toDisplayString(_ctx.formData.ordered_qty), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t("common.information")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", {
            class: _normalizeClass(["timeline-label", _ctx.formData.items.length == 0 ? 'no-data' : ''])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.items, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["timeline-item parent", {
                'text-gray-800': item.crossed === 1,
                'text-gray-500': item.crossed === 0,
              }])
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDate(item.date)), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["timeline-badge", {
                  'bg-success': item.crossed === 1,
                  'bg-secondary': item.crossed === 0,
                }])
                  }, [
                    (item.key == 'New')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                      : (item.key == 'Order Received')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                        : (item.key == 'Order Placed')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_21))
                          : (item.key == 'Estimated Delivered')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                            : (item.key == 'Inventory Confirmation')
                              ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                              : (item.key == 'EU Shipment')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                                : (item.key == 'Overseas Shipment')
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                                  : (item.key == 'CN Shipment')
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                                    : (item.key == 'Transit & QC Warehouse')
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                                      : (
                    item.key == 'Transit Warehouse' ||
                    item.key == 'Bonded Warehouse' ||
                    item.key == 'Local Warehouse'
                  )
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                                        : (item.key == 'Export Customs Declaration')
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                                          : (item.key == 'Import Customs Declaration')
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                                            : (item.key == 'Domestic Delivery')
                                              ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                                              : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(item.node), 1)
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (node, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: _normalizeClass(["timeline-item child", {
                  'text-gray-700': node.crossed === 1,
                  'text-gray-500': node.crossed === 0,
                }])
                  }, [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDate(node.date)), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi bi-record-fill fs-2", {
                      'text-success': node.crossed === 1,
                      'text-gray-500': node.crossed === 0,
                    }])
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(node.node), 1)
                  ], 2))
                }), 128))
              ], 64))
            }), 128)),
            (_ctx.formData.items.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, " No Data "))
              : _createCommentVNode("", true)
          ], 2)
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_38,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("common.backToList")), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}